const light = '#f4f4f4'
const primary = '#4535AA'
const secondary = '#D6D1F5'
const warning = '#ED639E'
const info = '#B05CBA'

const colors = {
  light,
  primary,
  secondary,
  warning,
  info
}
export default colors
